import { EdicaoClienteInicial, EdicaoClienteModel } from "../models/edicaoClienteModel"
import { EdicaoClienteActionModel, EdicaoClienteActionsTypes } from "./edicaoClienteActions"

export function edicaoClienteReducer(
    state: EdicaoClienteModel,
    action: EdicaoClienteActionModel
): EdicaoClienteModel {
    switch (action.type) {
        case EdicaoClienteActionsTypes.CARREGAR:
            return action.payload

        case EdicaoClienteActionsTypes.ATUALIZAR_CAMPO:
            return { ...state, [action.payload.campo]: action.payload.valor }

        case EdicaoClienteActionsTypes.ATUALIZAR_ENDERECO: {
            const atualizado = action.payload
            if (!state.enderecos.some(e => e.id === atualizado.id)) return state
            return {
                ...state,
                enderecos: state.enderecos.map(e => (e.id === atualizado.id ? atualizado : e)),
            }
        }

        case EdicaoClienteActionsTypes.ADICIONAR_ENDERECO:
            return { ...state, enderecos: [...state.enderecos, action.payload] }

        case EdicaoClienteActionsTypes.REMOVER_ENDERECO:
            return {
                ...state,
                enderecos: state.enderecos.filter(e => e.id !== action.payload.id),
            }

        case EdicaoClienteActionsTypes.ATUALIZAR_ATIVO:
            return { ...state, ativo: action.payload.ativo }

        case EdicaoClienteActionsTypes.RESETAR:
            return EdicaoClienteInicial

        default:
            return state
    }
}
